import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import KPICard from '../../components/shared/KPICard';
import SectionDivider from '../../components/shared/SectionDivider';
import { pgvclCircles, feeders } from '../../data/mockData';

export default function DiscomCircles() {
  const [expandedCircle, setExpandedCircle] = useState<string | null>(null);

  return (
    <div className="p-6 space-y-6">
      <div className="flex gap-4">
        <KPICard title="Circles" value="5" subtext="PGVCL operational" />
        <KPICard title="Divisions" value="14" subtext="Under PGVCL" />
        <KPICard title="Feeders" value="82" subtext="Solar-connected" />
        <KPICard title="Avg MTTR" value="4.2h" subtext="Mean time to resolve" />
      </div>

      <div className="bg-white rounded-card border border-border shadow-card p-4">
        <SectionDivider title="Circle → Division → Feeder Hierarchy" subtitle="Click to expand" />
        <table className="w-full text-xs">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-2.5 text-text-tertiary font-medium">Circle</th>
              <th className="text-right py-2.5 text-text-tertiary font-medium">Plants</th>
              <th className="text-right py-2.5 text-text-tertiary font-medium">MWh Today</th>
              <th className="text-right py-2.5 text-text-tertiary font-medium">PR%</th>
              <th className="text-right py-2.5 text-text-tertiary font-medium">Active%</th>
              <th className="text-right py-2.5 text-text-tertiary font-medium">Alarms</th>
              <th className="text-right py-2.5 text-text-tertiary font-medium">MTTR (h)</th>
            </tr>
          </thead>
          <tbody>
            {pgvclCircles.map(circle => (
              <React.Fragment key={circle.id}>
                <tr
                  className={`border-b border-border/50 cursor-pointer hover:bg-bg-secondary transition-colors ${expandedCircle === circle.id ? 'bg-bg-tertiary' : ''}`}
                  onClick={() => setExpandedCircle(prev => prev === circle.id ? null : circle.id)}
                >
                  <td className="py-2.5">
                    <div className="flex items-center gap-2">
                      {expandedCircle === circle.id
                        ? <ChevronUp size={12} className="text-accent" />
                        : <ChevronDown size={12} className="text-text-tertiary" />}
                      <span className="font-medium text-accent">{circle.name}</span>
                    </div>
                  </td>
                  <td className="py-2.5 text-right text-text-secondary">{circle.plants}</td>
                  <td className="py-2.5 text-right font-medium text-text-primary">{circle.generationMWh.toLocaleString()}</td>
                  <td className={`py-2.5 text-right font-semibold ${circle.prPercent >= 75 ? 'text-success' : 'text-warning'}`}>{circle.prPercent}%</td>
                  <td className="py-2.5 text-right text-text-secondary">{circle.activePercent}%</td>
                  <td className={`py-2.5 text-right ${circle.alarms > 10 ? 'text-warning font-semibold' : 'text-text-secondary'}`}>{circle.alarms}</td>
                  <td className="py-2.5 text-right text-text-secondary">{circle.mttrHours}</td>
                </tr>

                {expandedCircle === circle.id && (
                  <tr>
                    <td colSpan={7} className="p-0">
                      <div className="bg-bg-secondary px-6 py-3 border-b border-border">
                        <p className="text-xs text-text-secondary mb-2">Feeders in {circle.name}</p>
                        <table className="w-full text-xs bg-white rounded-input border border-border overflow-hidden">
                          <thead>
                            <tr className="bg-bg-tertiary border-b border-border">
                              <th className="text-left py-2 px-3 text-text-tertiary font-medium">Feeder</th>
                              <th className="text-right py-2 px-3 text-text-tertiary font-medium">Plants</th>
                              <th className="text-right py-2 px-3 text-text-tertiary font-medium">MW</th>
                              <th className="text-right py-2 px-3 text-text-tertiary font-medium">Alarms</th>
                            </tr>
                          </thead>
                          <tbody>
                            {feeders.slice(0, 3).map(f => (
                              <tr key={f.id} className="border-b border-border/50 hover:bg-bg-secondary cursor-pointer">
                                <td className="py-2 px-3 font-medium text-text-primary">{f.name}</td>
                                <td className="py-2 px-3 text-right text-text-secondary">{f.plants}</td>
                                <td className="py-2 px-3 text-right text-text-secondary">{f.generationMW}</td>
                                <td className="py-2 px-3 text-right text-text-secondary">{f.alarms}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
